export default "__VITE_ASSET__CMqPOcQB__"